import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PropertySpecializations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const specializations = [{
    title: "Residential Masterpieces",
    description: "Transforming homes with meticulous detail and vibrant finishes.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559587/img/residential_interior_modern.png",
    link: "#",
    alt: "Modern residential interior with high-quality paint finish"
  }, {
    title: "Commercial Excellence",
    description: "Professional coating solutions for Townsville's business landmarks.",
    image: "https://mature-leech.10web.cloud/wp-content/uploads/2026/02/20240820_215425836_iOS-scaled.jpg?v=xcb4mvrxum",
    link: "#",
    alt: "Exterior of a commercial office building in Townsville"
  }];
  return <section id="property-specializations" className="bg-background py-24 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {specializations.map((spec, i) => <Card key={i} data-index={i} className="group relative overflow-hidden border-0 bg-transparent shadow-none rounded-none">
              <CardContent className="p-0">
                <AspectRatio ratio={4 / 5} className="relative overflow-hidden rounded-xl bg-muted">
                  <img src={spec.image} alt={spec.alt} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  
                  {}
                  <div className="absolute inset-0 bg-secondary/90 flex flex-col items-center justify-center text-center p-8 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    <h3 className="text-3xl md:text-4xl font-bold text-secondary-foreground mb-4 tracking-tight">
                      {spec.title}
                    </h3>
                    <p className="text-secondary-foreground/80 mb-8 max-w-xs mx-auto leading-relaxed">
                      {spec.description}
                    </p>
                    <Button asChild variant="outline" className="border-secondary-foreground text-secondary-foreground hover:bg-secondary-foreground hover:text-secondary transition-colors">
                      <Link to={spec.link}>
                        View Services <ArrowRight className="ml-2 h-4 w-4" />
                      </Link>
                    </Button>
                  </div>

                  {}
                  <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black/80 to-transparent opacity-100 transition-opacity duration-300 group-hover:opacity-0 md:hidden">
                    <h3 className="text-2xl font-bold text-white text-center">
                      {spec.title}
                    </h3>
                  </div>
                </AspectRatio>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}